<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Carriers
      </div>
      <v-spacer></v-spacer>
      <v-btn
        @click="goToDetails(0)"
        color="primary"
        small
        v-if="checkPermission('app_carrier_partner:carrier_create')"
        >Add Carrier</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="carriers"
      :loading="loader"
      :search="search"
      class="elevation-1 custom-icon-size"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Carrier"
                  v-model="name"
                  outlined
                  clearable
                  @click:clear="clearInput('this.name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="allServiceTypes"
                  outlined
                  v-model="service_type"
                  dense
                  chips
                  small-chips
                  label="Service"
                  @click:clear="clearInput('this.service_type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="addList.list_label_types"
                  outlined
                  v-model="label_type_id"
                  dense
                  chips
                  small-chips
                  item-text="name"
                  item-value="id"
                  label="Type of Label"
                  @click:clear="clearInput('this.label_type_id')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="statuses"
                  outlined
                  v-model="active"
                  dense
                  chips
                  small-chips
                  label="Status"
                  @click:clear="clearInput('this.active')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="settings"
                  outlined
                  v-model="settingUpdated"
                  label="Onboarding Status"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="offset-md-6">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class=""
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>
      <template v-slot:item.service_mode="{ item }">
        {{ capitalizeFirstLetter(item.service_mode) }}
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:item.settings_updated="{ item }">
        {{ item.settings_updated == 0 ? "Pending" : "Completed" }}
      </template>

      <template v-slot:item.website="{ item }">
        <a
          :href="item.website"
          target="_blank"
          rel="noopener noreferrer"
          v-if="item.website"
          >{{ item.website }}</a
        >
      </template>
      <template v-slot:item.active="{ item }">
        <span
          v-if="checkPermission('app_carrier_partner:toggle_carrier_state')"
        >
          <v-switch
            v-model="item.active"
            @change="confirmStatusChange(item)"
          ></v-switch>
        </span>
        <span v-else :class="item.active == true ? 'badge-active' : 'badge'">
          {{ item.active == true ? "Active" : "In-active" }}
        </span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_carrier_partner:carrier_edit')"
          >
            <v-icon
              medium
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="goToDetails(item.id)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_carrier_partner:tracking-events-list')"
          >
            <v-icon
              medium
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="uploadCarrier(item)"
            >
              mdi-upload
            </v-icon>
          </template>
          <span>Upload carrier events </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_carrier_partner:carrier_address_list')"
          >
            <v-icon
              medium
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="goToddress(item)"
            >
              mdi-map-marker
            </v-icon>
          </template>
          <span>View Address</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="
              checkPermission('app_carrier_partner:carrier-country-list') &&
              item.active
            "
          >
            <v-icon
              medium
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="goToUpload(item)"
            >
              mdi-upload-multiple
            </v-icon>
          </template>
          <span>Carrier coverage upload</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_carrier_partner:carrier-settings-list')"
          >
            <v-icon
              small
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="setting(item)"
            >
              mdi-cog
            </v-icon>
          </template>
          <span>Settings</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="dialogConfirm"
      text="Are you sure want to change status?"
      :loader="statusLoader"
      @confirm="changeStatus"
      @close="closeConfirm"
    />
    <RemoveLinehaul
      :dialog="remvLinehaul"
      :carrierId="carrierId"
      @close="remvLinehaul = false"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";
import RemoveLinehaul from "@/views/front/carriers/RemoveLinehaul";
import { countries, trackingServiceModes } from "@/config/data";
export default {
  components: {
    ConfirmDialog,
    RemoveLinehaul,
  },
  computed: {
    allCountries() {
      return Object.keys(countries).map((i) => {
        return {
          text: countries[i],
          value: i,
        };
      });
    },
    allTrackingServiceModes() {
      return Object.keys(trackingServiceModes).map((i) => {
        return {
          text: trackingServiceModes[i],
          value: i,
        };
      });
    },
  },
  data: () => ({
    options: {},
    paymentModes: [
      {
        text: "COD",
        value: "COD",
      },
      {
        text: "Prepaid",
        value: "Prepaid",
      },
      {
        text: "COD & Prepaid",
        value: "COD,Prepaid",
      },
    ],
    headers: [
      {
        text: "Name of Carrier",
        value: "name",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Service",
        value: "service_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type of label",
        value: "label_type_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Payment Mode",
        value: "service_payment_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Environment",
        value: "service_mode",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Settings Updated",
        value: "settings_updated",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "active",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
    ],
    carriers: [],
    editedIndex: -1,
    editedItem: {
      name: null,
      active: true,
    },
    search: null,
    dialogConfirm: false,
    loader: false,
    statusLoader: false,
    remvLinehaul: false,
    carrierId: null,
    active: "",
    label_type_id: "",
    service_type: "",
    name: "",
    filtersArr: {},
    carrierForm: false,
    carrierDetail: {},
    saveLoader: false,
    fileInput: null,
    addList: {},
    allServiceTypes: [],
    statuses: [
      {
        text: "Active",
        value: "true",
      },
      {
        text: "Inactive",
        value: "false",
      },
    ],
    settingUpdated: null,
    settings: [
      {
        text: "Completed",
        value: 1,
      },
      {
        text: "Pending",
        value: 0,
      },
    ],
  }),

  created() {
    this.getAddCarrierList();
  },
  watch: {
    options: {
      handler() {
        this.fetchCarriers();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getCarriers",
      "changeCarrierStatus",
      "snackBar",
      "addCarriers",
      "getAddCarrier",
    ]),
    ServiceTypes() {
      this.allServiceTypes = Object.keys(this.addList.list_service_type).map(
        (i) => {
          return {
            text: this.capitalizeFirstLetter(i),
            value: i,
          };
        }
      );
    },
    getAddCarrierList() {
      this.getAddCarrier().then((res) => {
        this.addList = res.data;
        this.ServiceTypes();
      });
    },
    fetchCarriers() {
      this.loader = true;
      this.getCarriers({
        pagination: 0,
        ...this.filtersArr,
      })
        .then((res) => {
          this.loader = false;
          this.carriers = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    closeConfirm() {
      this.dialogConfirm = false;
      this.carriers[this.editedIndex].active =
        !this.carriers[this.editedIndex].active;
    },
    setting(item) {
      this.$router.push({
        name: "CarrierSettings",
        params: {
          id: item.id,
          status: item.active,
        },
      });
    },
    confirmStatusChange(item) {
      this.carrierId = item.id;
      this.editedIndex = this.carriers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogConfirm = true;
    },

    changeStatus() {
      this.statusLoader = true;
      this.changeCarrierStatus({
        id: this.editedItem.id,
        state: this.editedItem.active ? "active" : "inactive",
      })
        .then((res) => {
          this.statusLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          if (this.editedItem.active == false) {
            this.remvLinehaul = true;
          }

          this.dialogConfirm = false;
        })
        .catch(() => {
          this.statusLoader = false;
          this.closeConfirm();
        });
    },

    editCarrier(item) {
      this.$router.push({
        name: "CarrierEdit",
        params: {
          id: item.id,
        },
      });
    },

    uploadCarrier(item) {
      this.$router.push({
        name: "CarrierEventsUpload",
        params: {
          id: item.id,
          name: item.name,
        },
        query: { carrier_id: item.id },
      });
    },
    clearInput(val) {
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      (this.active = ""),
        (this.label_type_id = ""),
        (this.service_type = ""),
        (this.name = "");
      this.settingUpdated = null;
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        active: this.active,
        label_type_id: this.label_type_id,
        service_type: this.service_type,
        name: this.name,
        settings_updated: this.settingUpdated,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getCarriers({
        ...this.filtersArr,
        pagination: 0,
      })
        .then((res) => {
          this.loader = false;
          this.carriers = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    goToddress(item) {
      this.$router.push({
        name: "CarriersAddresses",
        params: {
          id: item.id,
          name: item.name,
        },
      });
    },
    goToDetails(id) {
      this.$router.push({
        name: "carrierDetails",
        params: {
          id,
        },
      });
    },
    goToUpload(item) {
      this.$router.push({
        name: "CountryUpload",
        params: {
          id: item.id,
          name: item.name,
        },
        query: { carrier_id: item.id },
      });
    },

    getImage(url) {
      if (url == null || url == undefined || url == "") {
        return;
      } else {
        return "/images/logo/" + url.split("/").pop();
      }
    },

    collectFormData() {
      const payload = new FormData();
      for (const field in this.carrierDetail) {
        if (field === "logo") continue;
        payload.append(
          field,
          this.carrierDetail[field] === null ? "" : this.carrierDetail[field]
        );
      }
      if (this.fileInput) {
        payload.append("logo", this.fileInput);
        this.carrierDetail.logo = URL.createObjectURL(this.fileInput);
      }
      return payload;
    },
  },
};
</script>
<style>
.carrier-logo {
  max-width: 100px;
  height: 25px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
